import { Settings, Cog, HardHat, Wrench, Factory, Construction, Zap } from "lucide-react";

// Subtle animated industrial icons floating in the background.
// Pure CSS (no JS animation cost) — safe on mobile too.
export default function FloatingObjects({ density = "normal" }) {
  const items = [
    { Icon: Cog, top: "8%", left: "6%", size: 160, anim: "animate-gear-slow", delay: "0s", op: 0.07 },
    { Icon: Settings, top: "60%", left: "85%", size: 220, anim: "animate-gear-rev", delay: "0s", op: 0.06 },
    { Icon: Cog, top: "78%", left: "10%", size: 130, anim: "animate-gear-med", delay: "0.5s", op: 0.08 },
    { Icon: HardHat, top: "20%", left: "78%", size: 90, anim: "animate-float", delay: "1s", op: 0.1 },
    { Icon: Wrench, top: "45%", left: "4%", size: 110, anim: "animate-float", delay: "2.2s", op: 0.07 },
    { Icon: Factory, top: "84%", left: "70%", size: 130, anim: "animate-float", delay: "1.6s", op: 0.06 },
    { Icon: Construction, top: "30%", left: "50%", size: 140, anim: "animate-float", delay: "3s", op: 0.05 },
    { Icon: Zap, top: "12%", left: "40%", size: 70, anim: "animate-float", delay: "0.8s", op: 0.1 },
  ];
  const list = density === "low" ? items.slice(0, 4) : items;
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
      {list.map((it, idx) => {
        const Icon = it.Icon;
        return (
          <div
            key={idx}
            className={`absolute ${it.anim} text-metallic`}
            style={{
              top: it.top,
              left: it.left,
              animationDelay: it.delay,
              opacity: it.op,
            }}
          >
            <Icon style={{ width: it.size, height: it.size }} strokeWidth={0.8} />
          </div>
        );
      })}
    </div>
  );
}
